module.exports = __webpack_public_path__ + "static/img/5.995c9b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/5.png
// module id = a+zB
// module chunks = 0